import { createStructuredSelector } from 'reselect'

import {
   DELIVERY_PLAN_LIST,
   DELIVERY_PLAN_LIST_SUCCESS, 
   DELIVERY_PLAN_LIST_ERROR,
   DELIVERY_PLAN_PAGE_SET,
   DELIVERY_PLAN_SEARCH_SET,
   DELIVERY_PLAN_SEARCH_CHANGE,
   DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT,
   DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   DELIVERY_PLAN_ADD_SET,
   DELIVERY_PLAN_ADD_MODAL_SET,
   DELIVERY_PLAN_ADD,
   DELIVERY_PLAN_ADD_SUCCESS,
   DELIVERY_PLAN_ADD_ERROR,
   DELIVERY_PLAN_ADD_CHANGE,
   DELIVERY_PLAN_DETAIL,
   DELIVERY_PLAN_DETAIL_SUCCESS,
   DELIVERY_PLAN_DETAIL_ERROR,
   DELIVERY_PLAN_VIEW_MODAL_SET,
   DELIVERY_PLAN_EDIT_CHANGE,
   DELIVERY_PLAN_EDIT_MODAL_SET,
   DELIVERY_PLAN_UPDATE,
   DELIVERY_PLAN_UPDATE_SUCCESS,
   DELIVERY_PLAN_UPDATE_ERROR,
   DELIVERY_PLAN_VIEW_TAB_SET,
   DELIVERY_PLAN_UPLOAD_SET,
   DELIVERY_PLAN_UPLOAD_SET_SUCCESS,
   DELIVERY_PLAN_UPLOAD_SET_ERROR,
   DELIVERY_PLAN_UPLOAD_RESET
} from '../actions';

export const DELIVERY_PLAN_NAME = 'delivery_plan';
const NAME = DELIVERY_PLAN_NAME;

export const DeliveryPlanList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  DELIVERY_PLAN_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const DeliveryPlanListSuccess = (data) => ({
  type:  DELIVERY_PLAN_LIST_SUCCESS,
  payload: data
});

export const DeliveryPlanListError = (error) => ({
  type:  DELIVERY_PLAN_LIST_ERROR,
  payload: error
});

export const DeliveryPlanPageSet = (data) => ({
  type:  DELIVERY_PLAN_PAGE_SET,
  payload: data
});

export const DeliveryPlanSearchSet = (data) => ({
  type:  DELIVERY_PLAN_SEARCH_SET,
  payload: data
});

export const DeliveryPlanSearchChangeSet = (data) => ({
  type:  DELIVERY_PLAN_SEARCH_CHANGE,
  payload: data
});

export const DeliveryPlanSearchDeliveryOrderLineLot = (data) => ({
  type:  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const DeliveryPlanSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const DeliveryPlanSearchDeliveryOrderLineLotError = (error) => ({
  type:  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const DeliveryPlanAddChangeSet = (data) => ({
  type:  DELIVERY_PLAN_ADD_CHANGE,
  payload: data
});

export const DeliveryPlanAddSet = (data) => ({
  type:  DELIVERY_PLAN_ADD_SET,
  payload: data
});

export const DeliveryPlanAddModalSet = (data) => ({
  type:  DELIVERY_PLAN_ADD_MODAL_SET,
  payload: data
});

export const DeliveryPlanAdd = (data) => ({
  type:  DELIVERY_PLAN_ADD,
  payload: data
});

export const DeliveryPlanAddSuccess = (message) => ({
  type:  DELIVERY_PLAN_ADD_SUCCESS,
  payload: message
});

export const DeliveryPlanAddError = (error) => ({
  type:  DELIVERY_PLAN_ADD_ERROR,
  payload: error
});

export const DeliveryPlanDetail = (data) => ({
  type:  DELIVERY_PLAN_DETAIL,
  payload: data
});

export const DeliveryPlanDetailSuccess = (data) => ({
  type:  DELIVERY_PLAN_DETAIL_SUCCESS,
  payload: data
});

export const DeliveryPlanDetailError = (error) => ({
  type:  DELIVERY_PLAN_DETAIL_ERROR,
  payload: error
});

export const DeliveryPlanViewModalSet = (data) => ({
  type:  DELIVERY_PLAN_VIEW_MODAL_SET,
  payload: data
});

export const DeliveryPlanEditModalSet = (data) => ({
  type:  DELIVERY_PLAN_EDIT_MODAL_SET,
  payload: data
});

export const DeliveryPlanEditChangeSet = (data) => ({
  type:  DELIVERY_PLAN_EDIT_CHANGE,
  payload: data
});

export const DeliveryPlanUpdate = (data) => ({
  type:  DELIVERY_PLAN_UPDATE,
  payload: data
});

export const DeliveryPlanUpdateSuccess = (message) => ({
  type:  DELIVERY_PLAN_UPDATE_SUCCESS,
  payload: message.message
});

export const DeliveryPlanUpdateError = (error) => ({
  type:  DELIVERY_PLAN_UPDATE_ERROR,
  payload: error
});

export const DeliveryPlanViewTabSet = (data) => ({
  type:  DELIVERY_PLAN_VIEW_TAB_SET,
  payload: data
});

export const DeliveryPlanUploadSet = (file) => ({
  type:  DELIVERY_PLAN_UPLOAD_SET,
  payload: { file },
});

export const DeliveryPlanUploadSetSuccess = (items) => ({
  type:  DELIVERY_PLAN_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const DeliveryPlanUploadSetError = (error) => ({
  type:  DELIVERY_PLAN_UPLOAD_SET_ERROR,
  payload: error,
});

export const DeliveryPlanUploadReset= () => ({
  type:  DELIVERY_PLAN_UPLOAD_RESET
});

const delivery_plan = (state) => state[NAME];

export const DeliveryPlanSelector = createStructuredSelector({
  delivery_plan
})
 